export default {
    edit: 'Muokkaa',
    location: 'Sijainti + Ehdot',
    filter: 'Suodata',
};
